// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmValidation = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			errorClass: 'field--error',
			errorClassGrid: 'grid__item--error'
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function.
		methods.initContext = function ($context) {

			methods.setCurrentSettings($context);

			$.validator.addMethod("valueNotEquals", function(value, element, arg){
				return arg != value;
			}, "Please select an option.");

			$context.parent().not('.umbraco-forms-form').find('form').not('.header__search, .home-search-panel__form, #searchForm').validate({
				ignore: ".ignore",
				highlight: function (element, errorClass, validClass) {
					if (element.type === "radio" || element.type === "checkbox") {
						$(element).closest('.grid__item').addClass(settings.errorClassGrid);
					} else {
						$(element).parent().addClass(settings.errorClass);
					}
				},
				unhighlight: function (element, errorClass, validClass) {
					if (element.type === "radio" || element.type === "checkbox") {
						$(element).closest('.grid__item').removeClass(settings.errorClassGrid);
					} else {
						$(element).parent().removeClass(settings.errorClass);
					}
				},
				errorPlacement: function(error, element) {
					if (element[0].type === "radio" || element[0].type === "checkbox") {
						element.closest('.field').before(error);
					} else {
						element.before(error);
					}
				},
				errorClass: 'field__error',
				submitHandler: function(form) {

					$context.ajaxSubmit({
						success: function(responseText, statusText, xhr, $form) {

							var id = $(responseText).attr('id'),
									$newForm = $('#' + id);

							// Inserting response
							$context.parent().html(responseText);

							// Rebind
							$newForm.lmValidation();

							// Scroll to top on success
							$('body').animate({
								scrollTop: 0
							}, 500);
						},
						error: function(responseText, statusText, xhr, $form) {
							// Leaving error handling and commented console until confirmed with BED all working.
							//console.log(responseText, statusText, xhr, $form);
						}
					});
					return false;
				},
				rules: {
					'confirmEmail': {
						equalTo: 'email'
					},
					'selectBox': {
						valueNotEquals: ''
					},
					'hiddenRecaptcha': {
						required: function () {
							if (grecaptcha.getResponse() == '') {
								return true;
							} else {
								return false;
							}
						}
					},
				}
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};
	$(document).ready(function() {
		if($('form').length) {
			$('form').lmValidation();
		}
	});

}(jQuery));
